export const GUIDE_LINE_WIDTH = 375; // Standard iPhone width
export const GLOBAL_SCALE_MULTIPLIER = 0.9;

/**
 * Calculates a scaled size based on the current window innerWidth compared to a standard guideline width.
 * On desktop browsers (>600px), pins to 1.0x scale so the dev environment doesn't inflate or shrink the UI.
 */
export function scaleSize(size: number, applyMultiplier = true): number {
  if (typeof window === 'undefined') return size * (applyMultiplier ? GLOBAL_SCALE_MULTIPLIER : 1);
  const currentWidth = window.innerWidth;

  // If running on a real desktop/dev browser, lock scale to 1.0 (no inflation, no shrinking)
  if (currentWidth > 600) {
    return size * (applyMultiplier ? GLOBAL_SCALE_MULTIPLIER : 1);
  }

  // Mobile: scale proportionally within phone viewport, capped at 430px (iPhone 14 Pro Max)
  const effectiveWidth = Math.min(currentWidth, 430);
  const scale = effectiveWidth / GUIDE_LINE_WIDTH;
  // Clamp to [0.85, 1.0] so no edge device is ever too small or too large
  const clampedScale = Math.min(1.0, Math.max(0.85, scale));

  return size * clampedScale * (applyMultiplier ? GLOBAL_SCALE_MULTIPLIER : 1);
}

